import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.less';
import { Provider } from 'react-redux';
import { EventBusContext, eventBus } from 'context/eventbus';
import store from './redux/store';

ReactDOM.render(
  <Provider store={store}>
    <EventBusContext.Provider value={eventBus}>
      <App />
    </EventBusContext.Provider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
